import { client } from '@api/client';
import { URL } from '@api/urls';

import {
	IEditSiteDTO,
	IManageSiteValuesDTO,
	IRemoveTechnologyDTO,
	ISitesDTO,
	ITechnologyDTO,
} from '@interfaces/cells/dto/cellsDTO';
import { INokiaProfile, ISiteProfile, TSitesBySearch } from '@interfaces/cells/siteProfile';
import { IVendor } from '@interfaces/cmModule/dto/cmModuleDTO';
import { IId, IIdTitle, TVendorNameTitle } from '@interfaces/common/common';
import { IGroupOperationDTO, IIdDataDTO } from '@interfaces/common/defaultDTO';
import { IItemsResponse } from '@interfaces/common/response';
import { ICrowdCellProfile } from '@interfaces/crowdcell/crowdCells';
import { IAssetSmallDate } from '@interfaces/crowdcell/linkSite';
import { INameTitle, ISite } from '@awtg-ltd/react-map-component/dist/interfaces';

import { EVendorsValues } from '@enums/common';

const {
	vendors,
	siteTypes,
	siteId,
	crowdCells,
	unlinkedCrowdCells,
	sites,
	sitesFilter,
	technologies,
	deleteSites,
	technology,
	unlinkedSites,
	assetsRented,
	findBySiteId,
} = URL;

export const getVendors = (): Promise<TVendorNameTitle[]> => {
	return client.get(vendors);
};

export const getSiteTypes = (): Promise<IIdTitle[]> => {
	return client.get(siteTypes);
};

export const getTechnologies = (): Promise<INameTitle[]> => {
	return client.get(technologies);
};

export const getSiteId = (): Promise<IId<number>> => client.get(`${sites}${siteId}`);

export const createSite = (data: IManageSiteValuesDTO): Promise<void> => client.post(sites, data);

export const editSite = ({ values, id }: IEditSiteDTO): Promise<void> =>
	client.put(`${sites}/${id}`, values);

export const getSitesDB = (data: Omit<ISitesDTO, 'organizationId'>): Promise<IItemsResponse<ISite>> => {
	return client.get(sitesFilter, {
		params: data,
	});
};

export const removeSites = ({
	filter,
	ids,
	isAll,
}: IGroupOperationDTO<ISitesDTO | null>): Promise<void> =>
	client.post(deleteSites, {
		filter,
		ids,
		isAll,
	});

export const getSiteProfile = (id: string): Promise<ISiteProfile> => client.get(`${sites}/${id}`);

export const createNewTechnology = ({ id, data }: IIdDataDTO<ITechnologyDTO>): Promise<void> =>
	client.post(`${sites}/nokia/${id}/${technology}`, data);

export const editExistedTechnology = ({ id, data }: IIdDataDTO<ITechnologyDTO>): Promise<void> =>
	client.put(`${sites}/nokia/${id}/${technology}`, data);

export const removeTechnology = ({ id, technologyValue }: IRemoveTechnologyDTO): Promise<void> =>
	client.delete(`${sites}/nokia/${id}/${technology}/${technologyValue}`);

export const getUnlinkedSites = ({
	vendor = EVendorsValues.limenet,
}: IVendor): Promise<INokiaProfile[]> =>
	client.get(`${sites}${unlinkedSites}`, {
		params: {
			vendor,
		},
	});

export const getUnlinkedCrowdCells = (): Promise<ICrowdCellProfile[]> => {
	return client.get(`${crowdCells}${unlinkedCrowdCells}`);
};

export const getRentedAssets = (): Promise<IItemsResponse<IAssetSmallDate>> => client.get(assetsRented);

export const findBySiteID = (searchValue: string): Promise<IItemsResponse<TSitesBySearch>> => {
	return client.get(findBySiteId, {
		params: {
			searchValue,
		},
	});
};
